module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_2-2600abc1c164418ae06b24cca17da72f.png";